export const UPLOAD_JAR_FILE = 'UPLOAD_JAR_FILE';
export const UPLOAD_JAR_FILE_SUCCESSFUL = 'UPLOAD_JAR_FILE_SUCCESSFUL';
export const UPLOAD_JAR_FILE_FAIL = 'UPLOAD_JAR_FILE_FAIL';

export const GET_JAR_FILE = 'GET_JAR_FILE';
export const GET_JAR_FILE_SUCCESSFUL = 'GET_JAR_FILE_SUCCESSFUL';
export const GET_JAR_FILE_FAIL = 'GET_JAR_FILE_FAIL';
